export default (props) => {
	const dialogMessages = props.state.dialogMessages;
	dialogMessages.push(
		{
			value: props.module.value,
			type: props.module.type,
			content: props.module.content,
			side: true
		}
	);
	props.setState({
		typingText: false,
		dialogMessages
	})
}